import { render, staticRenderFns } from "./InquiriesView.vue?vue&type=template&id=63a4a280&lang=true"
import script from "./InquiriesView.vue?vue&type=script&lang=js"
export * from "./InquiriesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports